type UCWindow = Window & typeof globalThis & {
    UCOrderReceived: (result: any) => void;
    UCOnLoadedReceived: () => void;
}

export default UCWindow;
